export var GamePhases;
(function (GamePhases) {
    GamePhases["SetMoves"] = "SetMoves";
    GamePhases["SelectMove"] = "SelectMove";
})(GamePhases || (GamePhases = {}));
